module.exports = __webpack_public_path__ + "img/logo.efda5cef.webp";